import * as React from 'react'
import './index.scss'
import { SelfServiceHeaderProps } from './types'
import { Icon } from '@petz/ds-icon'
import { ModuleContext } from '../../hooks/ModuleContext'

export function SelfServiceHeader({ closedTitle, openedTitle, showContent, openContainer, isOpen, isMobile }: Readonly<SelfServiceHeaderProps>) {
  const closeButtonMobileRef = React.useRef<HTMLDivElement | null>(null)
  const serviceHeaderStartRef = React.useRef<HTMLButtonElement | null>(null)
  const whatsappButtonRef = React.useRef<HTMLDivElement | null>(null)
  const { module, setModule } = React.useContext(ModuleContext)

  function handleOpenContainer(event: React.MouseEvent<HTMLButtonElement>) {
    if (!isOpen) {
      setTimeout(() => {
        showContent(true)
      }, 400)
    }

    if (whatsappButtonRef.current?.contains(event.target as Node)) {
      setModule('whatsapp')
    } else {
      setModule('all')
    }

    const closeButtonMobile = closeButtonMobileRef.current
    let closeButtonMobileClicked = false
    if (closeButtonMobile) closeButtonMobileClicked = closeButtonMobile.contains(event.target as Node)

    if (module === 'all' || !closeButtonMobileRef.current || closeButtonMobileClicked) {
      showContent(false)

      openContainer(!!whatsappButtonRef.current?.contains(event.target as Node))
    }
  }

  const headerTitle = closedTitle ?? 'Ajuda?'
  const headerOpenedTitle = openedTitle ?? 'Como podemos ajudar?'
  const titleText = isOpen || isMobile ? headerOpenedTitle : headerTitle
  const imageSize = isOpen ? '28px' : '36px'

  return (
    <>
      {isMobile ? <button aria-label="service-header-starter" className="service-header-starter" onClick={() => openContainer(false)} ref={serviceHeaderStartRef} /> : null}
      <button className={`service-header-container ${isOpen ? 'open' : ''}`} onClick={handleOpenContainer} aria-label="service-header-container">
        <div className="service-header-content">
          {module !== 'all' && isOpen && isMobile ? <Icon size="md" name="petz-chevron-left" variant="line" /> : null}
          {!isMobile && (
            <div className="title-image-container">
              <img alt="Imagem de camaleão" className="title-image" src="https://static-file.petz.com.br/web-self-service/logo-img.webp" width={imageSize} height={imageSize} />
            </div>
          )}
          <p className="title-text">{titleText}</p>
        </div>
        {isOpen && !isMobile && (
          <div className="close-service-container minus">
            <Icon size="md" name="minus" variant="line" />
          </div>
        )}
        {isMobile && (
          <div aria-label="close-button-mobile" className="close-service-container times-circle" ref={closeButtonMobileRef}>
            <Icon size="lg" name="times-circle" variant="line" />
          </div>
        )}
        {!isOpen && (
          <div className="service-header-whatsapp" aria-label="service-header-whatsapp" ref={whatsappButtonRef}>
            <Icon name="whatsapp" variant="line" size={'md'} />
          </div>
        )}
      </button>
      {isMobile && <div className="service-header-bottom" />}
    </>
  )
}
